import { UnknownAction, Dispatch, Middleware } from 'redux';
import { service } from '@src/service';
import type { RootState } from '@src/store/index';

export const tracker: Middleware<unknown, RootState> = () => (next) => (action) => {
  const ret = next(action) as Dispatch;
  service.tracker.reduxActionListener(action as UnknownAction);
  return ret;
};
